<template>
  <svg
    width="26"
    height="20"
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2H24"
      stroke="url(#paint0_linear_185_1742)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 10H17"
      stroke="url(#paint1_linear_185_1742)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 18H11"
      stroke="url(#paint2_linear_185_1742)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_185_1742"
        x1="24"
        y1="2.57787"
        x2="20.1338"
        y2="10.951"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_185_1742"
        x1="17"
        y1="10.5779"
        x2="12.2836"
        y2="17.5422"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_185_1742"
        x1="11"
        y1="18.5779"
        x2="5.95784"
        y2="23.0451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
